import { CircularProgress, Stack } from "@mui/material";

export function FullScreenPreloader() {
  return (
    <Stack
      alignItems={"center"}
      justifyContent={"center"}
      width={"100%"}
      height={"100vh"}
    >
      <CircularProgress />
    </Stack>
  );
}
